@if (loading) {
  <div class="discussion-view__loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<div
  #listCommentEl
  class="discussion-view__list"
  (scroll)="onScroll($event)"
  >
  <div class="discussion-view__spacer"></div>
  @for (comment of listComment; track comment.id; let i = $index) {
    <div class="discussion-view__item" [ngClass]="{ first: i === 0 }">
      <div class="discussion-view__item-content">
        <app-comment-item
          [id]="comment.id"
          [data]="comment"
          (selected)="versionSelected.emit(comment)"
          (mouseenter)="
            comment.imageReference ? commentHover.emit(comment) : ''
          "
          (mouseleave)="commentHover.emit(null)"
        ></app-comment-item>
      </div>
    </div>
  }
</div>

<div class="discussion-view__input">
  <form class="example-form">
    <mat-form-field class="example-full-width">
      @if (commentBoundingBox) {
        <mat-icon matPrefix>rate_review</mat-icon>
      }
      <textarea
        [(ngModel)]="commentText"
        [ngModelOptions]="{ standalone: true }"
        matInput
        class="form-control form-control-sm"
        placeholder="Type a comment.."
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        (keydown)="triggerFunction($event)"
        (focus)="focusComment(true)"
        (focusout)="focusComment(false)"
      ></textarea>
      <mat-icon matSuffix class="cursor-pointer" (click)="sendComment()"
        >send</mat-icon
        >
      </mat-form-field>
    </form>
  </div>
